import { render, staticRenderFns } from "./user-profile.vue?vue&type=template&id=222ec124&scoped=true&"
import script from "./user-profile.vue?vue&type=script&lang=js&"
export * from "./user-profile.vue?vue&type=script&lang=js&"
import style0 from "./user-profile.vue?vue&type=style&index=0&id=222ec124&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222ec124",
  null
  
)

export default component.exports